import { useContext } from 'react';

import AWSCognitoContext from '../contexts/aws-cognito-context';

import type { AWSCognitoContextType } from '../contexts/aws-cognito-context';

// ==============================|| AUTH HOOKS ||============================== //

const useAuth = (): AWSCognitoContextType => {
  const context = useContext(AWSCognitoContext);
  

  if (!context) throw new Error('context must be used inside provider');

  return context;
};

export default useAuth;
